module.exports = __webpack_public_path__ + "static/media/key-glow-sparkles-2.c23d727a.png";